import { Component, OnInit, Inject } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AppService } from "src/_services/app.service";
import { EventService } from "src/_services/event.service";
import { MatDialog, MAT_DIALOG_DATA } from "@angular/material";

@Component({
  selector: "app-commission-market-market-level",
  templateUrl: "./commission-market-market-level.component.html",
  styleUrls: ["./commission-market-market-level.component.scss"],
})
export class CommissionMarketMarketLevelComponent implements OnInit {
  providerId: string;
  sportId: string;
  competitionId: string;
  eventId: string;
  marketsList: any;
  competitionName: string;
  eventName: string;
  marketModalData: any;
  DisplayedColumns: string[] = [
    "MarketId",
    "MarketName",
    "EventName",
    "EventId",
    "Action",
  ];

  constructor(
    private appService: AppService,
    private router: Router,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private eventService: EventService
  ) {}

  ngOnInit() {
    this.providerId = this.route.snapshot.params.providerId;
    this.sportId = this.route.snapshot.params.sportId;
    this.competitionId = this.route.snapshot.params.competitionId;
    this.eventId = this.route.snapshot.params.eventId;
    this.route.queryParams.subscribe((params) => {
      this.competitionName = params["competitionName"];
      this.eventName = params["eventName"];
    });

    this.getMarkets();
  }

  getMarkets() {
    try {
      this.appService
        .getMarketData(this.providerId, this.sportId, this.eventId)
        .subscribe((res) => {
          this.marketsList = res.markets;
        });
    } catch (err) {
      console.log(err);
    }
  }

  manageMarketCommission(data) {
    try {
      this.eventService
        .getModalMarketData(
          data.EventId,
          data.MarketId,
          this.providerId,
          this.sportId
        )
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            this.marketModalData = res.marketStatus;
            this.dialog.open(manageMarketCommissionModal, {
              backdropClass: "backdropBackground",
              hasBackdrop: true,
              data: this.marketModalData,
            });
          } else {
            if (res.errorDescription === "Invalid Token!") {
              sessionStorage.clear();
              this.router.navigateByUrl("/login");
            }
          }
        });
    } catch (err) {}
  }
}

@Component({
  selector: "dialog-data-example-dialog",
  templateUrl: "./market-commission-modal.html",
  styleUrls: ["./market-commission-modal.scss"],
})
export class manageMarketCommissionModal {
  displayColumns: string[] = [
    "EventId",
    "EventName",
    "MarketId",
    "MarketName",
    "OperatorId",
    "ProviderStatus",
  ];
  tabledata = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private eventService: EventService,
    private appService: AppService
  ) {
    this.tabledata = data;
  }
  handleChangeStatus(e, data) {
    if (e.checked) {
      this.appService
        .addCommissionMarket({
          eventId: data.EventId,
          marketId: data.MarketId,
          providerId: data.ProviderId,
          sportId: data.SportId,
          operatorId: data.OperatorId,
          commissionEnabled: true,
          operatorName: data.operatorName,
        })
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            this.appService.openSuccessBar("Blocked");
          } else {
            this.appService.openErrorBar(res.errorDescription);
          }
        });
    } else {
      this.appService
        .addCommissionMarket({
          eventId: data.EventId,
          marketId: data.MarketId,
          providerId: data.ProviderId,
          sportId: data.SportId,
          operatorId: data.OperatorId,
          commissionEnabled: false,
          operatorName: data.operatorName,
        })
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            this.appService.openSuccessBar("Blocked");
          } else {
            this.appService.openErrorBar(res.errorDescription);
          }
        });
    }
  }
}
manageMarketCommissionModal;
